import {
	createSlice,
	current
} from '@reduxjs/toolkit';
import {
	getWarehouseGroupList,
	addNewWarehouseGroup,
	updateWarehouseGroup,
	deleteWarehouseGroup,
	getWarehouseGroup,
	checkWarehouseGroupExists
} from '../warehouseGroup/thunk';

export const initialState = {
	itemWarehouseGroupList: [],
	itemWarehouseGroup: null,
	isWarehouseGroupLoading: false,
	isWarehouseGroupSuccess: false,

	dataWarehouseGroup: null,
	statementList: [],
	statementListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
	registerDisabled: false,
	requireReloadSelectionItemsGrid: false,
	exists: false
};

const WarehouseGroupSlice = createSlice({
	name: 'WarehouseGroup',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		}
	},
	extraReducers: builder => {
		builder.addCase(getWarehouseGroup.fulfilled, (state, action) => {
			state.isWarehouseGroupLoading = false;
			state.isWarehouseGroupSuccess = true;
			state.itemWarehouseGroup = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getWarehouseGroup.pending, state => {
			state.isWarehouseGroupLoading = true;
			state.isWarehouseGroupSuccess = null;
			state.itemWarehouseGroup = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getWarehouseGroup.rejected, (state, action) => {
			state.isWarehouseGroupLoading = false;
			state.isWarehouseGroupSuccess = false;
			state.itemWarehouseGroup = null;
			state.error = action.error.message;
			state.isLoadingList = false;
		});

		builder.addCase(getWarehouseGroupList.pending, state => {
			state.isWarehouseGroupSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getWarehouseGroupList.fulfilled, (state, action) => {
			state.itemWarehouseGroupList = action.payload;
			state.statementList = action.payload;
			state.isLoadingList = false;
			state.isWarehouseGroupSuccess = true;

			let statementListSelect = [];
			action.payload.map(item =>
				statementListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.statementListSelect = statementListSelect;
		});
		builder.addCase(getWarehouseGroupList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isWarehouseGroupSuccess = true;
		});
		builder.addCase(addNewWarehouseGroup.fulfilled, (state, action) => {
			state.itemWarehouseGroupList.push(action.payload);
			state.statementList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewWarehouseGroup.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewWarehouseGroup.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		builder.addCase(updateWarehouseGroup.fulfilled, (state, action) => {
			state.itemWarehouseGroupList = state.itemWarehouseGroupList.map(warehouseGroupList =>
				warehouseGroupList._id.toString() === action.payload._id.toString()
					? { ...warehouseGroupList, ...action.payload}
					: warehouseGroupList
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(updateWarehouseGroup.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updateWarehouseGroup.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteWarehouseGroup.fulfilled, (state, action) => {
			state.itemWarehouseGroupList = current(state.itemWarehouseGroupList).filter(
				item => item._id !== action.payload._id
			);
			state.statementList = current(state.statementList).filter(item =>
				item._id !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
			state.requireCloseModal = true;
		});
		builder.addCase(deleteWarehouseGroup.pending, (state, action) => {
			state.isLoadingList = true;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
		});
		builder.addCase(deleteWarehouseGroup.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDelete = true;
		});
		builder.addCase(checkWarehouseGroupExists.fulfilled, (state, action) => {
			state.exists = action.payload.exists;
		});
		builder.addCase(checkWarehouseGroupExists.pending, (state, action) => {
			state.exists = false;
		});
		builder.addCase(checkWarehouseGroupExists.rejected, (state, action) => {
			state.exists = false;
		});
	},
});

export const {
	setRequireCloseModal
} = WarehouseGroupSlice.actions;

export default WarehouseGroupSlice.reducer;